import React, { PureComponent, Fragment } from 'react';
import { Link } from "react-router-dom";
import GifBrowserStrip from './GifBrowserStrip/GifBrowserStrip';
import './GifBrowser.scss';

import { scrollTo } from '../../_helpers.js';

class GifBrowser extends PureComponent { 
    constructor(props) {
        super(props);   
        this.state = {
            data :  props.data,
            rowCnt : 1,
            rows : [],
            row : props.row,
            gif : props.gif
        }    
    }
    componentDidMount () {
        // ready
        this.renderRows(0);
    }
    handleClick = (url) => {
        let _row = url.split('/')[1],
            _gif = url.split('/')[2];
        
        this.props.history.push(`${url}`);
        
        // sub foldered GIF 
            if (url.split('/')[3])
                _gif = _gif + "/" + url.split('/')[3]
        
        this.setState({
            row : _row,
            gif : _gif
        })
        
        this.props.handleModal(_row, _gif);
    }

    renderRows = (num) => {
        this.setState({
            rowCnt : this.state.rowCnt + num
        })
    }
    render () {
        let _gifs = this.state.data.slice(0, this.state.rowCnt),
            _chk = this.state.rowCnt < this.state.data.length,
            _class = this.props.layout;
        return (
            <Fragment>
                <div class={ `GifBrowser ${_class}` }>
                    { _gifs.map((category, index) => {
                        return <GifBrowserStrip category={ category } activeRow={ this.state.row } activeGif={ this.state.gif } handleClick={ this.handleClick } callback={ this.renderRows } />
                    })}
                </div>
                { _chk && 
                    <div class="GifBrowser--placeholder"></div>
                }
            </Fragment>
        );
    }
}

export default GifBrowser;